import { Container, Grid } from '@material-ui/core'
import React, { useState, useEffect, useMemo } from 'react'
import {
  Traslates,
  DialogPdf,
  HeaderHLPure,
  ButtonHLPure,
  InputHLPure,
  SimpleLoading,
  TextAreaHLPure,
  LabelModalPure,
  PanelBarGLPure,
  CheckBoxHLPure,
  ButtonAddHLPure,
  InstructionsPure,
  DataPickerHLPure,
  DialogYesNoHLPure,
  DialogSystemGLPure,
  GridSelectionHLPure,
  PromotionalFooterPure,
  DialogExtractEntities,
  ClassificationPanelPure,
} from '../../pures'
import './digital-vault-upload.css'
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { useTranslation } from 'react-i18next'
import DocumentDataPanel from './DocumentDataPanel'
import ThirdPartyDocumentPanel from './ThirdPartyDocumentPanel'
import '../digital-vault-document/digital-vault-document.view.css'

const INFO_TYPE_DOCUMENT = Number(process.env.REACT_APP_INFO_TYPE_DOCUMENT)
const INFO_TYPE_EXP = Number(process.env.REACT_APP_INFO_TYPE_EXP)

const getSubcategoryPath = (tree, id, path = []) => {
  for (let i = 0; i < tree.length; i++) {
    const element = tree[i]
    if (element.subcategory.id === id) {
      return [...path, element.subcategory.id]
    }
    const nextLevelSearch = getSubcategoryPath(element.items || [], id, [...path, element.subcategory.id])
    if (nextLevelSearch) return nextLevelSearch
  }
}

const traceSubcategoryPath = (tree, path, hierarchicalIndex = '') => {
  if (path.length === 0) return hierarchicalIndex.slice(1)

  let catIndex = tree.findIndex(i => i.subcategory.id === path[0])
  if (catIndex !== -1) {
    return traceSubcategoryPath(tree[catIndex].items || [], path.slice(1), `${hierarchicalIndex}_${catIndex}`)
  } else {
    return []
  }
}

const DigitalVaultUploadView = (props) => {
  const {
    isLoading,
    showLoadingRequesting,
    toggleErrorRequesting,
    showCompletedRequesting,
    toggleLoadingRequesting,
    showErrorRequesting,
    toggleCompletedRequesting,
    messageError,
    showWarningModal,
    toggleWarningModal,
    warningMessage,
    warningTitle,
    fileType,
    companies,
    subcategoryTree,
    allTypeDocuments,
    typeDocuments,
    setTypeDocuments,
    handleFile,
    deleteFile,
    uploadData,
    handleUploadDataChange,
    permission,

    onCancel,
    onSave,
    invalidFields,
    setInvalidFields,

    documentId,
    handleUpdateDocument,
    urlPdf,
    blobAWS,
    handleWathchExp,

    showUploadBtn,
    showBtnCancel,
    rejectUploadDocument,
    showDialogSendDocToOcr,
    closeModalSendToOcr,
    documentsToOCR,
    handleCheckBoxDoc,
    totalCredits,
    setFileType,

    // Categorias y subcategorias
    handleTreeNodeClick,
    strBtn,
    categoriesData,
    showCategoryWarningModal,
    toggleCategoryWarningModal,
    openSubcategories,
    showCategoryInputDialog,
    setShowCategoryInputDialog,
    categoryNameError,
    setCategoryName,
    categoryName,
    handleCreateCategoryOrSubcategory,
    openCategories,
    selectedTreeNodes,
    expandedTreeNodes,

    // Tags
    onBlurInputTag,
    disableElements,
    handleInputTag,
    inputTag,
    handleDeleteChipTag,
    tags,

    // Dates
    onChangeDatepicker,
    onChangeDatepickerDateEnd,
    dateStart,
    dateEnd,
    formatCeleb,
    formatVen,
    limitDateDue,

    // Checkboxes
    handleChangeCheckConfidential,
    confidential,
    handleChangeCheckNotify,
    notify,

    //Variables
    customVariables,
    setCustomVariables,
    formatVariables,

    // Entidades
    openModalExtractEntities,
    saveExtractedEntities,
    entitiesExtracted,
    showEntitiesSuccessModal,
    messageDialog,
    ENV,

    // clasificar doocumentos lista
    documentGroups = [],
    documentTemplates = [],
    onSaveThirdPartyRequest,

    // Estado y callbacks para panel de terceros
    selectedUsers,
    requestDeadline,
    userInstructions,
    setSelectedUsers,
    userDocumentLists,
    secondApprovalUser,
    setRequestDeadline,
    setUserInstructions,
    enableSecondApproval,
    setUserDocumentLists,
    setSecondApprovalUser,
    setEnableSecondApproval
  } = props

  const { t, i18n } = useTranslation()
  const [viewCancelDialog, setViewCancelDialog] = useState(false)
  const [showRejectDialog, setShowRejectDialog] = useState(false)
  const [realFileType, setRealFileType] = useState('')

  const canCreateSubcategory = useMemo(() => {
    if (!permission || !permission.subcategory) {
      return false
    }

    return permission.subcategory.create === true
  }, [permission])

  const pdfAWS = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={true} isSSRActive={false} />, [urlPdf])

  useEffect(() => {
    setRealFileType(fileType)
  }, [fileType])


  const onDataChange = (event, field) => {
    let value

    if (field === 'typeDocument') {
      value = event.value
    } else if (field === 'pathBreadcrumb') {
      const path = getSubcategoryPath(subcategoryTree, event.item.subcategory.id)
      value = path
    } else if (field === 'categoryId') {
      value = parseInt(event.target.value)
    } else {
      value = event.target.value
    }

    setInvalidFields(prev => prev.filter(i => i !== field))
    handleUploadDataChange(field, value)
  }

  useEffect(() => {
    if (subcategoryTree.length && uploadData.pathBreadcrumb && uploadData.pathBreadcrumb.length) {
      const hierarchicalIndex = traceSubcategoryPath(subcategoryTree, uploadData.pathBreadcrumb)
      setSelected([hierarchicalIndex])
      setExpand(prev => ({
        ids: [...new Set([...(prev?.ids || []), ...uploadData.pathBreadcrumb])],
        idField: 'subcategory.id'
      }))
    } else {
      setSelected([''])
      setExpand({ ids: [], idField: 'subcategory.id' })
    }
  }, [subcategoryTree, uploadData.pathBreadcrumb])


  const [, setSelected] = useState([''])
  const [, setExpand] = useState({
    ids: [],
    idField: 'subcategory.id'
  })


  const [fileShown, setFileShown] = useState({})
  const pdf = useMemo(() => {
    const pdfUrl = fileShown.file && fileShown.fileBase64 ? `data:application/pdf;base64,${fileShown.fileBase64}` : '';
    return <PdfViewerAction url={pdfUrl} isExtended={true} customHeight='912px' isSSRActive={false} />
  }, [fileShown])

  useEffect(() => {
    let files = uploadData.uploadedFiles
    if (files.length === 0) setFileShown({})
    else if (files.length === 1) setFileShown(files[0])
    else if (files.findIndex(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64) === -1) setFileShown(files[0])
  }, [uploadData.uploadedFiles, fileShown.name, fileShown.fileBase64])

  const [fileSelected, setFileSelected] = useState({})
  useEffect(() => {
    if (!fileSelected || !fileSelected.fileBase64) return
    setFileShown(fileSelected)
  }, [fileSelected])

  useEffect(() => {
    if (!uploadData || !uploadData.infoType) return
    const infoTypeString = (uploadData.infoType === 1) ? ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT : ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
    const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoTypeString })
    setTypeDocuments(typeDocumentsFiltered)
  }, [uploadData, uploadData.infoType, ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT, ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE, allTypeDocuments, setTypeDocuments])


  let skip = 0
  if (fileShown.file) {
    const i = uploadData.uploadedFiles.findIndex(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64)
    if (i !== -1) skip = Math.floor(i / 5) * 5
  }

  const subcategoryRequiredMsg = t('digitalVaultUpload.error.select.subcategory')

  //TODO: funcion para arrastrar y soltar archivos + mas modal de validacion de nuevo documento
  const [showAlert, setShowAlert] = useState(false)
  const [messageAlert, setMessageAlert] = useState('')

  const showAlertDialog = (message) => {
    setMessageAlert(message)
    setShowAlert(true)
  }

  const closeAlertDialog = () => {
    setShowAlert(false)
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
  }

  const handleDrop = async (e) => {
    e.preventDefault()

    const files = e.dataTransfer.files
    const MAX_FILE_SIZE_MB = 80
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

    if (uploadData.infoType === INFO_TYPE_DOCUMENT) {
      if (files.length > 1) {
        showAlertDialog(t('digitalVaultUploadView.description.rule'))
        return
      }

      if (files[0].size > MAX_FILE_SIZE_BYTES) {
        const formattedSize = formatBytes(files[0].size)
        const limitFormatted = formatBytes(MAX_FILE_SIZE_BYTES)
        showAlertDialog(
          `${t('loadFields.max.file.size')} '${files[0].name}' ${t('loadFields.exceed.max.file.size')} ${formattedSize} ${t('loadFields.exceed.max.file.size.limit')} ${limitFormatted}.`
        )
        return
      }

      await handleFile({ target: { files } })
    }

    if (uploadData.infoType === INFO_TYPE_EXP) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > MAX_FILE_SIZE_BYTES) {
          const formattedSize = formatBytes(files[i].size)
          const limitFormatted = formatBytes(MAX_FILE_SIZE_BYTES)
          showAlertDialog(
            `${t('loadFields.max.file.size')} '${files[i].name}' ${t('loadFields.exceed.max.file.size')} ${formattedSize} ${t('loadFields.exceed.max.file.size.limit')} ${limitFormatted}.`
          )
          return
        }
      }

      await handleFile({ target: { files } })
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  let treeRef = null

  const onEnterTag = (e) => {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      e.preventDefault()
      if (inputTag.trim() !== '') {
        onBlurInputTag()
      }
    }
  }

  const uploadFilesIcon = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_UPLOAD_FILES_ICON}`

  return (
    <>
      <div className='standard-wrapper digitalVaultUploadView'>
        {
          isLoading
            ? <SimpleLoading />
            : <>
              <Container>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <HeaderHLPure title={`${uploadData.infoType === INFO_TYPE_DOCUMENT ? t('digitalVaultUploadView.title.document') : t('digitalVaultUploadView.title.exp')}`} />
                  </Grid >

                  <Grid item xs={12} md={6} spacing={4}>
                    {/* DATOS DE DOCUMENTO */}
                    <DocumentDataPanel
                      t={t}
                      uploadData={uploadData}
                      onDataChange={onDataChange}
                      documentId={documentId}
                      invalidFields={invalidFields}
                      fileShown={fileShown}
                      setFileType={setFileType}
                      handleWathchExp={handleWathchExp}
                      deleteFile={deleteFile}
                      setFileSelected={setFileSelected}
                      disableElements={disableElements}
                      inputTag={inputTag}
                      handleInputTag={handleInputTag}
                      onBlurInputTag={onBlurInputTag}
                      onEnterTag={onEnterTag}
                      tags={tags}
                      handleDeleteChipTag={handleDeleteChipTag}
                      dateStart={dateStart}
                      dateEnd={dateEnd}
                      onChangeDatepicker={onChangeDatepicker}
                      onChangeDatepickerDateEnd={onChangeDatepickerDateEnd}
                      formatCeleb={formatCeleb}
                      formatVen={formatVen}
                      limitDateDue={limitDateDue}
                      confidential={confidential}
                      handleChangeCheckConfidential={handleChangeCheckConfidential}
                      notify={notify}
                      handleChangeCheckNotify={handleChangeCheckNotify}
                    />

                    {/* CLASIFICACION */}
                    <Grid style={{ marginTop: "15px" }}>
                      <ClassificationPanelPure
                        // Empresa
                        companies={companies}
                        companyId={uploadData.companyId}
                        onCompanyChange={(e) => onDataChange(e, 'companyId')}
                        requireCompany={true}
                        showCompanyError={invalidFields.includes('companyId')}
                        companyErrorMessage={t('digitalVaultUpload.error.select.company')}

                        // Categorías y Subcategorías
                        categoriesData={categoriesData}
                        categoryId={uploadData.categoryId}
                        onTreeNodeClick={handleTreeNodeClick}
                        onAddSubcategory={openSubcategories}
                        requireCategory={true}
                        showCategoryError={invalidFields.includes('categoryId') || invalidFields.includes('pathBreadcrumb')}
                        categoryErrorMessage={
                          invalidFields.includes('categoryId') || invalidFields.includes('pathBreadcrumb')
                            ? subcategoryRequiredMsg
                            : ''
                        }

                        // Tipo de documento
                        typeDocuments={typeDocuments}
                        selectedTypeDocument={uploadData.typeDocument}
                        onTypeDocumentChange={(e) => onDataChange(e, 'typeDocument')}
                        infoType={uploadData.infoType}
                        requireTypeDocument={true}
                        showTypeDocError={invalidFields.includes('typeDocument')}
                        typeDocErrorMessage={
                          t('digitalVaultUpload.error.select.file.type')
                        }

                        // Validaciones
                        invalidFields={invalidFields}

                        // Diálogo de categoría
                        showCategoryDialog={showCategoryInputDialog}
                        onCloseCategoryDialog={() => setShowCategoryInputDialog(false)}
                        onSubmitCategory={handleCreateCategoryOrSubcategory}
                        categoryName={categoryName}
                        onCategoryNameChange={setCategoryName}
                        categoryNameError={categoryNameError}
                        dialogType={strBtn}

                        // Callbacks opcionales
                        treeRefCallback={(ref) => { treeRef = ref }}
                        onUploadDataChange={handleUploadDataChange}
                        documentId={documentId}
                        setCustomVariables={setCustomVariables}
                        showAddSubcategoryButton={true}
                        canCreateSubcategory={canCreateSubcategory}
                        selectedNodes={selectedTreeNodes}
                        expandedNodes={expandedTreeNodes}
                      />
                    </Grid>
                    {/* Solicitud de documentos a terceros */}
                    <Grid style={{ marginTop: "15px" }}>
                      <ThirdPartyDocumentPanel
                        t={t}
                        uploadData={uploadData}
                        onDataChange={onDataChange}
                        documentId={documentId}
                        invalidFields={invalidFields}
                        fileShown={fileShown}
                        setFileType={setFileType}
                        handleWathchExp={handleWathchExp}
                        deleteFile={deleteFile}
                        setFileSelected={setFileSelected}
                        disableElements={disableElements}
                        inputTag={inputTag}
                        handleInputTag={handleInputTag}
                        onBlurInputTag={onBlurInputTag}
                        onEnterTag={onEnterTag}
                        tags={tags}
                        handleDeleteChipTag={handleDeleteChipTag}
                        dateStart={dateStart}
                        dateEnd={dateEnd}
                        onChangeDatepicker={onChangeDatepicker}
                        onChangeDatepickerDateEnd={onChangeDatepickerDateEnd}
                        formatCeleb={formatCeleb}
                        formatVen={formatVen}
                        limitDateDue={limitDateDue}
                        confidential={confidential}
                        handleChangeCheckConfidential={handleChangeCheckConfidential}
                        notify={notify}
                        handleChangeCheckNotify={handleChangeCheckNotify}
                        documentGroups={documentGroups}
                        documentTemplates={documentTemplates}

                        // Estado y callbacks para terceros
                        selectedUsers={selectedUsers}
                        setSelectedUsers={setSelectedUsers}
                        userDocumentLists={userDocumentLists}
                        setUserDocumentLists={setUserDocumentLists}
                        userInstructions={userInstructions}
                        setUserInstructions={setUserInstructions}
                        requestDeadline={requestDeadline}
                        setRequestDeadline={setRequestDeadline}
                        enableSecondApproval={enableSecondApproval}
                        setEnableSecondApproval={setEnableSecondApproval}
                        secondApprovalUser={secondApprovalUser}
                        setSecondApprovalUser={setSecondApprovalUser}
                      />
                    </Grid>
                  </Grid >

                  {
                    showUploadBtn ?
                      (
                        <Grid item xs={12} md={6} onDragOver={handleDragOver} onDrop={handleDrop} >
                          <DialogSystemGLPure
                            showWarningRequesting={showAlert}
                            message={messageAlert}
                            toggleWarningRequesting={closeAlertDialog}
                          />
                          <Grid container spacing={3} alignContent='flex-start'>
                            <Grid item xs={12}>
                              <div className='digitalVaultUploadView-upload'>

                                <div className='digitalVaultUploadView-upload-section'>
                                  <div className='digitalVaultUploadView-instructions'>
                                    <InstructionsPure
                                      instructions={
                                        uploadData.infoType === INFO_TYPE_DOCUMENT
                                          ? [
                                            <>
                                              {t('digitalVaultUploadView.instructions.1.document')}{' '}
                                              <strong>{t('digitalVaultUploadView.instructions.1.document_strong')}</strong>{' '}
                                              {t('digitalVaultUploadView.instructions.1.document_2')}
                                            </>,
                                            <>
                                              {t('digitalVaultUploadView.instructions.2.document')}{' '}
                                              <strong>{t('digitalVaultUploadView.instructions.2.document_strong')}</strong>.
                                            </>,
                                            t('digitalVaultUploadView.instructions.3.document'),
                                          ]
                                          : uploadData.infoType === INFO_TYPE_EXP
                                            ? [
                                              <>
                                                {t('digitalVaultUploadView.instructions.1.file')}{' '}
                                                <strong>{t('digitalVaultUploadView.instructions.1.file_strong')}</strong>
                                              </>,
                                              <>
                                                {t('digitalVaultUploadView.instructions.2.file')}{' '}
                                                <strong>{t('digitalVaultUploadView.instructions.2.file_strong')}</strong>
                                              </>,
                                              t('digitalVaultUploadView.instructions.3.file'),
                                              t('digitalVaultUploadView.instructions.4.file'),
                                            ]
                                            : []
                                      }
                                    />
                                  </div>
                                  <div className='digitalVaultUploadView-upload-icon'>
                                    <label htmlFor='file-upload' className='digitalVaultUploadView-file-upload'>
                                      <input
                                        type='file'
                                        id='file-upload'
                                        required
                                        multiple={uploadData.infoType === INFO_TYPE_EXP}
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) => handleFile(e, showAlertDialog)}
                                      />
                                      <div className='upload-icon-box'>
                                        <img src={uploadFilesIcon} alt="upload files" style={{ width: '60px', height: '60px' }} />
                                        <span style={invalidFields.includes('files') ? { color: 'red' } : null}>
                                          {t('digitalVaultUploadView.upload.file')}
                                          {uploadData.infoType === INFO_TYPE_EXP && '(s)'}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                            {uploadData.uploadedFiles.length && fileShown.file
                              ?
                              <>
                                {
                                  fileType === 'pdf' &&
                                  <Grid item xs={12}>
                                    {pdf}
                                  </Grid>
                                }
                                {
                                  fileType === 'image' &&
                                  <Grid item xs={12}>
                                    <img
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      className='digitalVaultUploadView-image'
                                    />
                                  </Grid>
                                }
                                {
                                  fileType === 'video' &&
                                  <Grid item xs={12}>
                                    <video
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      controls
                                      disablePictureInPicture
                                      disableRemotePlayback
                                      className='digitalVaultUploadView-video'
                                    />
                                  </Grid>
                                }
                                {
                                  fileType === 'audio' &&
                                  <Grid item xs={12}>
                                    <audio
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      controls
                                      style={{ width: '100%' }}
                                    />
                                  </Grid>
                                }
                              </>
                              : null
                            }
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          {
                            realFileType === 'pdf'
                            && <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  {pdfAWS ? pdfAWS : null}
                                </div>
                                <div className='followUpDocumentEntities-documentPDF-pdf-btn'>
                                  <DialogPdf blobUrl={blobAWS} />
                                </div>
                              </div>
                            </Grid>
                          }
                          {
                            realFileType === 'image' &&
                            <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  <img
                                    src={urlPdf}
                                    className='digitalVaultUploadView-image'
                                    alt='preview'
                                  />
                                </div>
                              </div>
                            </Grid>
                          }
                          {
                            realFileType === 'video' &&
                            <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  <video
                                    src={urlPdf}
                                    controls
                                    disablePictureInPicture
                                    disableRemotePlayback
                                    className='digitalVaultUploadView-video'
                                  />
                                </div>
                              </div>
                            </Grid>
                          }
                        </>
                      )
                  }

                  <Grid container item xs={12} justify='flex-end' className='digitalVaultUploadView-buttongroup'>
                    <ButtonHLPure
                      nameBtn={t('button.cancel')}
                      onClickBtn={(e) => setViewCancelDialog(true)}
                    />
                    {
                      showBtnCancel && (
                        <ButtonHLPure
                          nameBtn={t('button.reject')}
                          onClickBtn={() => setShowRejectDialog(true)}
                        />
                      )
                    }
                    <ButtonHLPure
                      nameBtn={t('button.save')}
                      primary
                      onClickBtn={() => {
                        const ocrMode = entitiesExtracted
                          ? 'Extraer entidades'
                          : ENV.PREFERENCE_PROCESS_DOCUMENT_BUTTON_NO_EXTRACT
                        if (documentId) {
                          handleUpdateDocument(true, ocrMode)
                        } else if (selectedUsers && selectedUsers.length > 0) {
                          onSaveThirdPartyRequest(ocrMode)
                        } else {
                          onSave(null, ocrMode)
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PromotionalFooterPure />
                  </Grid>
                </Grid >
              </Container >
              {showCategoryWarningModal && (
                <DialogSystemGLPure
                  showWarningRequesting={showCategoryWarningModal}
                  message={(props?.categoryWarningMessage && props.categoryWarningMessage.trim()) ? props.categoryWarningMessage : subcategoryRequiredMsg}
                  toggleWarningRequesting={toggleCategoryWarningModal}
                  showButton
                  messageButton={t('button.close')}
                />
              )}
              {
                viewCancelDialog && (
                  <DialogSystemGLPure
                    showConfirm={true}
                    handleConfirmDeleteFlowClose={() => {
                      setViewCancelDialog(false)
                    }}
                    labelCancelConfirmation={t('digitalVaultUploadView.modal.button.cancel')}
                    titleDialog={t('digitalVaultUploadView.modal.title')}
                    handleConfirmDeleteFlowSubmit={onCancel}
                    labelSubmitConfirmation={t('digitalVaultUploadView.modal.button.accept')}
                    confirmMessage={t('digitalVaultUploadView.modal.question')}
                  />
                )
              }
              {
                showRejectDialog && (
                  <DialogYesNoHLPure
                    cancel={() => {
                      setShowRejectDialog(false)
                    }}
                    textBtnCancel={t('button.cancel')}
                    saveBtn={t('button.accept')}
                    titleDialog={t('digitalVaultUploadView.modal.reject.title')}
                    handleSubmit={(e) => {
                      setShowRejectDialog(false)
                      rejectUploadDocument(e)

                    }}
                  >
                    <div className='digitalVaultUploadView-modal-reject'>
                      <LabelModalPure label={t('digitalVaultUploadView.modal.reject.question')} />
                      <LabelModalPure label={t('digitalVaultUploadView.modal.reject.label')} />
                    </div>
                  </DialogYesNoHLPure>
                )
              }

              {
                showEntitiesSuccessModal && (
                  <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}

                    showCompletedRequesting={showCompletedRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    messageComplete={messageDialog}
                    showErrorRequesting={showErrorRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    messageError={messageError}
                  />
                )
              }
              <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                messageComplete={messageDialog}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                messageError={messageError}

                isWarnign={showWarningModal}
                messageWarning={warningMessage}
                handleWarningClose={() => {
                  toggleWarningModal(false, '', '')
                }}
                handleWarningSubmit={() => {
                  toggleWarningModal(false, '', '')
                }}
                showBtnSubmitWarning={true}
                labelWarningBtnSubmit={t('button.close')}
                titleDialog={warningTitle || t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.warning.title')}
              />
            </>
        }
      </div >
    </>
  )
}

export default DigitalVaultUploadView